export default `/* Ids Text Component */
:host([hidden]) {
  display: none !important;
}

:host([line-clamp]) {
  display: block;
  overflow: hidden;
  min-width: 0;
}

:host([overflow=ellipsis]) {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}

:host([mask-type=button-mask]),
:host([mask-type=icon-mask]) {
  display: flex;
  align-items: center;
  gap: var(--ids-text-mask-btn-gap);
}
:host([mask-type=button-mask]) .mask-btn,
:host([mask-type=icon-mask]) .mask-btn {
  display: flex;
}

.ids-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-weight: var(--ids-font-weight-normal);
  display: block;
  margin: 0;
  color: currentColor;
  font-size: var(--ids-font-size-sm);
  text-decoration: unset;
}
.ids-text.audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  position: none;
}
.ids-text.error {
  color: var(--ids-color-text-error);
}
.ids-text.label {
  color: var(--ids-color-text-label);
}
.ids-text.label.color-variant-alternate {
  color: var(--ids-color-text-inverse);
}
.ids-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.ellipsis div.has-tab-width {
  max-width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.has-line-clamp {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
  max-width: 100%;
}
.ids-text.has-line-clamp.line-clamp-one {
  white-space: nowrap;
  display: block;
}
.ids-text.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-text.semi-bold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-text.lighter {
  font-weight: var(--ids-font-weight-light);
}
.ids-text.text-align-start {
  text-align: start;
}
.ids-text.text-align-end {
  text-align: end;
}
.ids-text.text-align-center {
  text-align: center;
}
.ids-text.text-align-justify {
  text-align: justify;
}
.ids-text.status-gray::before, .ids-text.status-error::before, .ids-text.status-info::before, .ids-text.status-success::before, .ids-text.status-warning::before {
  display: inline-flex;
  margin-inline-end: var(--ids-input-margin-bottom);
  border-radius: var(--ids-border-radius-circle);
  content: "";
  height: 8px;
  width: 8px;
  position: relative;
  top: -2px;
}
.ids-text.status-gray {
  color: var(--ids-color-text-label);
}
.ids-text.status-gray::before {
  background-color: var(--ids-color-text-label);
}
.ids-text.status-error {
  color: var(--ids-color-text-error);
}
.ids-text.status-error::before {
  background-color: var(--ids-color-text-error);
}
.ids-text.status-info {
  color: var(--ids-color-text-info);
}
.ids-text.status-info::before {
  background-color: var(--ids-color-text-info);
}
.ids-text.status-success {
  color: var(--ids-color-text-success);
}
.ids-text.status-success::before {
  background-color: var(--ids-color-text-success);
}
.ids-text.status-warning {
  color: var(--ids-color-text-warning);
}
.ids-text.status-warning::before {
  background-color: var(--ids-color-text-warning);
}
.ids-text.pre {
  white-space: pre;
}
.ids-text.pre-wrap {
  white-space: pre-wrap;
}
.ids-text.nowrap {
  white-space: nowrap;
}
.ids-text.pre-line {
  white-space: pre-line;
}
.ids-text.break-spaces {
  white-space: break-spaces;
}
.ids-text.normal {
  white-space: normal;
}
.ids-text.word-break-normal {
  word-break: normal;
}
.ids-text.word-break-break-all {
  word-break: break-all;
}
.ids-text.word-break-keep-all {
  word-break: keep-all;
}
.ids-text.word-break-break-word {
  overflow-wrap: anywhere;
}

:host(.inline) .ids-text {
  display: inline;
}

:host([word-wrap]) {
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}

.inline,
[display=inline] {
  display: inline;
}

.ids-text-color-unset {
  color: unset;
}

:host(.message-text) .ids-text {
  color: unset;
}
:host(.message-text) .ids-text.error {
  color: unset;
}

::slotted(.highlight) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(.audible) {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

::slotted(.filter) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin);
  vertical-align: middle;
  position: relative;
  top: -2px;
}

:host([font-size="32"]) ::slotted(ids-icon),
:host([font-size="28"]) ::slotted(ids-icon),
:host([font-size="24"]) ::slotted(ids-icon),
:host([font-size="20"]) ::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin-lg);
}

::slotted(ids-alert) {
  margin: var(--ids-text-alert-margin);
  vertical-align: sub;
}

/* Ids Typography System */
.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: uppercase;
}

.ids-text-12 {
  font-size: var(--ids-font-size-2xs);
  text-transform: uppercase;
}

.ids-text-14 {
  font-size: var(--ids-font-size-xs);
}

.ids-text-16 {
  font-size: var(--ids-font-size-sm);
}

.ids-text-20 {
  font-size: var(--ids-font-size-md);
}

.ids-text-24 {
  font-size: var(--ids-font-size-lg);
}

.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}

.ids-text-32 {
  font-size: var(--ids-font-size-2xl);
}

.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}

.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}

.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}

.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-block-end: 0;
}

.ids-text-color-muted.ids-text,
:host([disabled]) .ids-text {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.label,
:host([disabled]) .ids-text.label {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.color-variant-alternate.label,
:host([disabled]) .ids-text.color-variant-alternate.label {
  color: var(--ids-color-text-subtle);
}
.ids-text-color-muted.ids-text.status-base, .ids-text-color-muted.ids-text.status-error, .ids-text-color-muted.ids-text.status-info, .ids-text-color-muted.ids-text.status-success, .ids-text-color-muted.ids-text.status-warning,
:host([disabled]) .ids-text.status-base,
:host([disabled]) .ids-text.status-error,
:host([disabled]) .ids-text.status-info,
:host([disabled]) .ids-text.status-success,
:host([disabled]) .ids-text.status-warning {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.status-error::before, .ids-text-color-muted.ids-text.status-info::before, .ids-text-color-muted.ids-text.status-success::before, .ids-text-color-muted.ids-text.status-warning::before,
:host([disabled]) .ids-text.status-error::before,
:host([disabled]) .ids-text.status-info::before,
:host([disabled]) .ids-text.status-success::before,
:host([disabled]) .ids-text.status-warning::before {
  background-color: var(--ids-color-text-disabled);
}

:host([class=label-checkbox]) .audible {
  position: relative;
  line-height: 1;
  height: unset;
}

::slotted(ids-badge) {
  position: relative;
  margin-inline-start: 8px;
  top: 1px;
  vertical-align: top;
}

:host([label-wrap=ellipsis]) .ids-text {
  display: block;
  width: 100%;
  max-inline-size: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-text {
  display: block;
  max-inline-size: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis][line-clamp]) .ids-text.has-line-clamp,
:host([label-wrap=ellipsis-no-stretch][line-clamp]) .ids-text.has-line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}

:host([label-wrap=wrap-no-stretch]) .ids-text {
  max-inline-size: 75%;
}

:host([label-wrap=wrap]) .ids-text,
:host([label-wrap=wrap-no-stretch]) .ids-text {
  overflow-wrap: anywhere;
}

:host([label-width]),
:host([label-width]) .ids-text,
:host([label-width][tooltip]) .ids-text,
:host([label-width][label-wrap=ellipsis-no-stretch]) .ids-text,
:host([label-width][label-wrap=wrap-no-stretch]) .ids-text {
  display: block;
  width: var(--ids-label-width);
  max-inline-size: var(--ids-label-width);
  inline-size: var(--ids-label-width);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
